// extracted by mini-css-extract-plugin
export default {"container":"_03_DrawCurvedLine_container__N2wTs"};